import type { AgentManifest } from '@indipia/shared';
import { routes, shareRoutes } from './src/routes';

// 스튜디오 홈 "현장 작업물 슬라이드오버"가 이 화면을 라우트 없이 직접 마운트한다
// (스튜디오 개선 설계서 §9·§11 컴포넌트 마운트).
export { SiteDetailMain, type SiteDetailMainProps } from './src/main/SiteDetailMain';

export const manifest: AgentManifest = {
  agentId: 'photo-organizer',
  routes,
  shareRoutes,
  menuItems: [
    {
      id: 'photo-organizer',
      label: '인디포토',
      icon: 'images',
      path: '/agents/photo-organizer',
      category: 'common',
      order: 10,
    },
  ],
  permissions: ['OWNER', 'STAFF'],
};
